import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// MUI imports
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

// Project imports
import Part1 from "./Part1";
import Part2 from "./Part2";
import { TrainingCentreRegContext } from "../helperFunctions";

import { fetchAllActiveSkillsTreg, fetchTrainerByEmail } from "../../../Actions";
import FormCompletionSuccess from "./CompletedSuccess";


const steps = [
  {
    title: "Select Training Centre",
    subTitle: "Get Centre Details",
  },
  {
    title: "Update Training Centre Details",
    subTitle: "Sections 1 - 2 & 8",
  },
];

const FormStepper = () => {
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));

  const grayedOutStyles = {
    backgroundColor: "#f0f0f0",
    color: "black !important",
    cursor: "not-allowed",
  };
  const styleClasses = {
    parentContainer: {
      marginTop: "100px",
      paddingBottom: "4rem",
      paddingLeft: largeScreen ? "80px" : "24px",
      paddingRight: largeScreen ? "80px" : "24px",
    },
    stepperContainer: {
      marginTop: "24px",
      maxWidth: "800px", 
      margin: "auto", 
    },
    labelContainer: {
      marginBottom: "40px",
    },
    labelText: {
      marginBottom: "5px",
    },
    formContainer: {
      marginTop: "30px",
    },
  };

  const globalDispatch = useDispatch();
  const trainingCentreRegReducer = (globalState) => globalState.trainingCentreRegReducer;
  const { listOfActiveSkills } = useSelector(trainingCentreRegReducer);
  const trainersReducer = (state) => state.trainersReducer;
    const { trainingCenterDetails } = useSelector(trainersReducer);

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const [parsedListOfSkills, setParsedListOfSkills] = useState([]);
  const [emailValue, setEmailValue] = useState("");
  const [emailHasValue, setEmailHasValue] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    globalDispatch(fetchAllActiveSkillsTreg());
  }, []);

  // parse list of skills to {id, label} format
  useEffect(() => {
    if (listOfActiveSkills.length > 0) {
      let parseResult = [];
      listOfActiveSkills.map((skill) => {
        const newObj = {
          id: skill.id,
          label: skill.name,
        };
        parseResult.push(newObj);
      });
      setParsedListOfSkills(parseResult);
    }
  }, [listOfActiveSkills]);

  useEffect(() => {
    if (emailHasValue) {
      globalDispatch(fetchTrainerByEmail(emailValue));
    }
  }, [emailHasValue]);

  return (
    <TrainingCentreRegContext.Provider 
    // value={contextObject}
    >
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          {steps.map((stepInfo) => {
            return (
              <Step key={stepInfo.title}>
                <StepLabel> {stepInfo.title} </StepLabel>
              </Step>
            );
          })}
        </Stepper>


        {/* Form Page Content */}
        <Box style={{ maxWidth: "1000px", margin: "auto", paddingTop: "20px" }}>
              {activeStep === 0 && (
                <Part1
                  styleClasses={styleClasses}
                  grayedOutStyles={grayedOutStyles}
                  handleNext={handleNext}
                  emailValue={emailValue}
                  setEmailValue={setEmailValue}
                  setEmailHasValue={setEmailHasValue}
                />
              )}
              {activeStep === 1 && (
                <Part2
                parsedListOfSkills={parsedListOfSkills}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  setFormSuccess={setFormSuccess}
                  trainingCenterDetails={trainingCenterDetails}
                />
              )}
              {formSuccess && <FormCompletionSuccess />}
              </Box>
      </Box>
    </TrainingCentreRegContext.Provider>
  );
};

export default FormStepper;
